//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import paginationControlsTemplate from '@partials/pagination-controls.html';

(function() {
  angular.module('curalate')
        .directive('paginationControls', () => ({
          restrict: 'E',
          scope: {
            disabled: '=ngDisabled',
            page: '=',
            pageChanged: '&',
            pageSize: '=',
            pageSizeOptions: '&',
            pageSizeChanged: '&',
            numPages: '=',
            totalCount: '=',
          },
          template: paginationControlsTemplate,
          controller: ['$scope',
            function($scope) {
              $scope.model = {
                pageInputValue: null,
              };

              $scope.model.setPage = function(page) {
                $scope.pageChanged({ page });
              };

              $scope.model.setPageSize = function(pageSize) {
                $scope.pageSizeChanged({ pageSize });
              };

              $scope.model.pageInputKeyUp = function(event) {
                let page;
                let maxPage;

                if (event.keyCode === 13) {
                  page = parseInt($scope.model.pageInputValue, 10);

                  if (page) {
                    maxPage = $scope.numPages;
                    page = page > maxPage ? maxPage : Math.max(page, 1);

                    $scope.model.pageInputValue = null;

                    $scope.pageChanged({ page });
                  }
                }
              };
            },
          ],
          link(scope, element, attrs) {
            if (attrs.hasOwnProperty('dropup')) {
              element.find('.form-horizontal').addClass('dropup');
            }
          },
        }),
    );
})();
